<div class="project-plan-wrap" [ngClass]="{'has-empty-value': isEmpty, 'disabled': disabled}">
  <div class="table-wrapper">
    <p-table [value]="projectPlanData" [(selection)]="selectedProjectPlanRows">
      <ng-template pTemplate="header">
        <tr>
          <td class="p-element"></td>
          <td class="p-element"></td>
          <td class="p-element" style="width: 35%">{{ descriptionHeader }}</td>
          <td class="p-element" style="width: 25%">{{ startDateHeader }}</td>
          <td class="p-element" style="width: 25%">{{ endDateHeader }}</td>
          <td class="p-element" style="width: 15%">{{ durationHeader }}</td>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-projectPlanRow let-index="rowIndex">
        <tr>
          <td class="table-checkbox">
            <app-checkbox-button
              [(state)]="projectPlanRow.selected"
              (stateChange)="onRowSelect($event, projectPlanRow)"
              [disabled]="disabled"
              ariaLabel="Select to mark row for deletion via delete button in the end of the table"
            ></app-checkbox-button>
          </td>
          <td>
            <p class="index-text">{{ index + 1}}</p>
          </td>
          <td>
            <textarea
              *ngIf="!disabled"
              pInputTextarea
              autoResize="true"
              type="text"
              (change)="handleChange()"
              (keyup)="removeLastWords(projectPlanRow)"
              [disabled]="disabled"
              [readonly]="disabled"
              [(ngModel)]="projectPlanRow.description"
              [placeholder]="descriptionPlaceholder"
              [attr.aria-label]="descriptionPlaceholder"
            ></textarea>
            <p
              *ngIf="disabled"
              class="description-text"
              [ngClass]="projectPlanRow.description ? '' : 'description-placeholder'"
            >
              {{ projectPlanRow.description ? projectPlanRow.description : descriptionPlaceholder }}
            </p>
          </td>
          <td>
            <div class="p-field p-field-custom">
              <div class="p-float-label">
                <p-calendar
                  [(ngModel)]="projectPlanRow.startDateObj"
                  [disabled]="disabled"
                  appendTo="body"
                  showIcon="true"
                  dateFormat="mm-dd-yy"
                  [monthNavigator]="true"
                  dataType="string"
                  showButtonBar="true"
                  [minDate]="setupEarliestStartDateObj"
                  [maxDate]="projectPlanRow.endDateJsDate ? projectPlanRow.endDateJsDate : setupLatestEndDateObj"
                  (onSelect)="handleStartDateChange($event, projectPlanRow)"
                  (onInput)="handleStartDateChange($event, projectPlanRow)"
                  (onClearClick)="handleStartDateChange($event, projectPlanRow)"
                  [inputId]="'start-date-row-' + index"
                >
                </p-calendar>
                <label [for]="'start-date-row-' + index">Start Date</label>
              </div>
            </div>
          </td>
          <td>
            <div class="p-field p-field-custom">
              <div class="p-float-label">
                <p-calendar
                  [(ngModel)]="projectPlanRow.endDateObj"
                  [disabled]="disabled"
                  appendTo="body"
                  showIcon="true"
                  dateFormat="mm-dd-yy"
                  [monthNavigator]="true"
                  dataType="string"
                  showButtonBar="true"
                  [minDate]="projectPlanRow.startDateJsDate ? projectPlanRow.startDateJsDate : setupEarliestStartDateObj"
                  [maxDate]="setupLatestEndDateObj"
                  (onSelect)="handleEndDateChange($event, projectPlanRow)"
                  (onInput)="handleEndDateChange($event, projectPlanRow)"
                  (onClearClick)="handleEndDateChange($event, projectPlanRow)"
                  [inputId]="'end-date-row-' + index"
                >
                </p-calendar>
                <label [for]="'end-date-row-' + index">End Date</label>
              </div>
            </div>
          </td>
          <td>
            <p class="duration-text">{{ projectPlanRow.durationInDays ? projectPlanRow.durationInDays + ' Days' : '' }}</p>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="footer" let-car>
        <tr [ngClass]="{ errored: !this.totalIsValid }">
          <td></td>
          <td></td>
          <td>
            {{ totalRequirements ? totalRequirements : "Total Plan Duration" }}
          </td>
          <td>
            <div class="p-field p-field-custom">
              <div class="p-float-label">
                <p-calendar
                  [(ngModel)]="earliestSelectedStartDateObj"
                  [disabled]="true"
                  appendTo="body"
                  showIcon="false"
                  dateFormat="mm-dd-yy"
                  [monthNavigator]="true"
                  [hideOnDateTimeSelect]="false"
                  dataType="string"
                  showButtonBar="true"
                  inputId="earliest-start-date"
                >
                </p-calendar>
                <label for="earliest-start-date">Earliest Start Date</label>
              </div>
            </div>
          </td>
          <td>
            <div class="p-field p-field-custom">
              <div class="p-float-label">
                <p-calendar
                  [(ngModel)]="latestSelectedEndDateObj"
                  [disabled]="true"
                  appendTo="body"
                  showIcon="false"
                  dateFormat="mm-dd-yy"
                  [monthNavigator]="true"
                  [hideOnDateTimeSelect]="false"
                  dataType="string"
                  showButtonBar="true"
                  inputId="latest-end-date"
                >
                </p-calendar>
                <label for="latest-end-date">Latest End Date</label>
              </div>
            </div>
          </td>
          <td>
            {{ getTotal() }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="footer-buttons-wrap" *ngIf="!disabled">
      <div class="btn-wrap">
        <p-button
          styleClass="button button-primary button-primary--medium"
          (click)="addNew()"
          [disabled]="this.projectPlanData.length === this.maxRows"
          ariaLabel="Add a new project plan row in the table above"
        >
          <span class="material-icons" aria-hidden="true">add</span>
          Add
        </p-button>
      </div>
      <div class="btn-wrap" [pTooltip]="showDeleteTooltip(this.selectedProjectPlanRows.length)">
        <p-button
          styleClass="button button-delete button-delete--medium"
          (click)="deleteSelectedProjectPlanRows()"
          [disabled]="this.projectPlanData.length === this.selectedProjectPlanRows.length || this.selectedProjectPlanRows.length === 0"
          [ariaLabel]="this.selectedProjectPlanRows.length === 0 ?
                      'Select rows with the checkbox from the table above to enable delete' :
                      this.selectedProjectPlanRows.length === 1 ?
                      'Delete ' + this.selectedProjectPlanRows.length + ' selected project plan row' :
                      this.projectPlanData.length === this.selectedProjectPlanRows.length ?
                      'You should leave at least one project plan row' :
                      'Delete ' + this.selectedProjectPlanRows.length + ' selected project plan rows'"
        >
          <span class="material-icons" aria-hidden="true">delete</span>
          Delete
        </p-button>
      </div>
    </div>
  </div>
  <ng-container *ngFor="let error of errors">
    <div class="formio-errors invalid-feedback" ref="messageContainer">
      <div class="form-text error">{{ error }}</div>
    </div>
  </ng-container>
</div>